import Menu from './Compartido/Menu.jsx';
import Embarcaciones from './DestinoOnboarding/Embarcaciones.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const DestinoOnboarding = (props) => {

    return (
        <main>
            <Scripts />
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="9_ListaDestinos"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <Embarcaciones
                lang={props.lang}
                destino={props.eldestino}
                barcos={props.propiedadesdestino}
                ruta={props.ruta}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
        </main>
    )
}
export default DestinoOnboarding;

